<template>
  <div class='h-topo-treebox'>
    <div class="h-toolbarBg">
      <div class='h-track-listSearchPadding h-inputBox-refresh'>
        <ejs-textbox :placeholder='SearchHoder' v-model='keywords' @keydown.native.enter='neSearch'>
          <span class='icon hero-icon hero-icon-search'></span>
        </ejs-textbox>
      </div>
      <div v-if='true'><button class="h-btn-refresh e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title='$t("Track.refreshTask")' @click='buttonClk()'/></div>
    </div>
    <div class='h-topo-tree h-track-list'>
      <ejs-listview ref='listview' :dataSource='neDatas' :fields='neFieldModel' showCheckBox='true' @select='neChange'></ejs-listview>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import bus from '../bus.js';

const { mapGetters, mapActions } = createNamespacedHelpers('trackConfig');
export default {
  name: 'left-panel',
  props: ['trackType'],
  data() {
    return {
      keywords: '',
      SearchHoder: this.$t('Track.searchResource'),
      neDatas: [],
      primaryDatas: [],
      neFieldModel: {
        text: 'name',
        tooltip: 'name',
        id: 'id'
      }
    };
  },
  computed: {
    ...mapGetters(['neVisionList']),
    ...mapGetters(['resourceIdList']),
  },
  created() {
    this.getNeListData();
  },
  methods: {
    ...mapActions(['setNeVision']),
    ...mapActions(['setResourceId']),
    getNeListData() {
      const This = this;
      This.$axios.get(`/lte/ems/auth/queryAllNodesByAuth`).then((neInfos) => {
        const neInfoData = neInfos.data.Equipment;
        This.primaryDatas = neInfoData;
        const neVisionList = {};
        neInfoData.forEach(neData => {
          neVisionList[neData.id] = [
            neData.displaySoftwareVersion,
            neData.typeCode,
            neData.name
          ];
        });
        this.setNeVision(neVisionList);
        this.findNodeId();
      });
    },
    buttonClk() {
      this.keywords = '';
      this.getNeListData();
    },
    neSearch() {
      if (this.keywords === '') {
        this.neDatas = this.primaryDatas;
      } else {
        const neDatas = this.primaryDatas.filter(neData => (neData.name.includes(this.keywords)));
        this.neDatas = neDatas;
      }
      const neNodeIdList = [];
      this.neDatas.forEach(data => {
          neNodeIdList.push(data.id);
      });
      this.setResourceId(neNodeIdList);
      this.$refs.listview.ej2Instances.selectItem(null);
      this.neChange('refresh');
    },
    neChange(args) {
      let selectedRecords = this.$refs.listview.getSelectedItems();
      bus.$emit('selectNeData', selectedRecords.data);     
    },
    findNodeId() {
      const This = this;
      This.roleNetMap = {};
      This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
        if (response && response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            This.roleNetMap[response.data[i]] = 1;
          }
          const neNodeList = [];
          const neNodeIdList = [];
          This.primaryDatas.forEach(neData => {
            if (This.roleNetMap[neData.id] && This.roleNetMap[neData.id] === 1) {
              neNodeList.push(neData);
              neNodeIdList.push(neData.id);
            }
          });
          This.primaryDatas = neNodeList;
          This.neDatas = neNodeList;
          This.setResourceId(neNodeIdList);
          bus.$emit('loadTrackTable', '');
        }
      });
    }
  }
};
</script>
